import React from 'react';
export function HeroSection() {
  // Function to handle navigation clicks with smooth scrolling
  const handleNavClick = sectionId => {
    // Prevent default anchor behavior
    event.preventDefault();
    // Get the target element to scroll to
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      // Scroll smoothly to the element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Update URL without page reload
      history.pushState(null, null, `#${sectionId}`);
    }
  };
  return <section className="relative bg-navy-900 overflow-hidden" data-id="element-228">
      <div className="absolute inset-0 bg-gradient-to-r from-navy-900 to-navy-800 opacity-90" data-id="element-229"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32" data-id="element-230">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-231">
          <div data-id="element-232">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-233">
              We Bring Businesses 20+ Leads/Month with Facebook Ads
            </h1>
            <p className="mt-6 text-xl text-gray-300 max-w-2xl" data-id="element-234">
              Stop wasting money on ineffective marketing. Our proven Facebook
              ad campaigns deliver qualified leads that convert into paying
              customers.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-235">
              <a href="#contact" className="px-8 py-4 rounded-md bg-white text-navy-900 font-bold text-lg shadow-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105" onClick={e => {
              e.preventDefault();
              handleNavClick('contact');
            }} data-id="element-236">
                Book Your Free Strategy Call
              </a>
              <a href="#services" className="px-8 py-4 rounded-md border-2 border-white text-white font-bold text-lg hover:bg-white hover:text-navy-900 transition-all duration-300 hover:scale-105" onClick={e => {
              e.preventDefault();
              handleNavClick('services');
            }} data-id="element-237">
                See How It Works
              </a>
            </div>
          </div>
          <div className="hidden md:block" data-id="element-238">
            <div className="relative rounded-lg overflow-hidden shadow-2xl" data-id="element-239">
              <img src="https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80" alt="Facebook ad campaign dashboard showing successful business results" className="w-full h-auto object-cover" data-id="element-240" />
              <div className="absolute inset-0 bg-navy-900 opacity-20" data-id="element-241"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}